<template>
  <div class="tabs-form main-create-page">
    <v-card>
      <v-card-text>
        <div class="d-flex align-center pb-2">
          <div>
            <h3 class="font-weight-700 font-size-24 color-custom-blue">
              <span v-if="templateId > 0">Edit</span>
              <span v-else>Create</span>
              Checklist
            </h3>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="custom-grey-border custom-bold-button"
            v-on:click="goBack"
          >
            <v-icon small left>mdi-keyboard-backspace</v-icon>
            Back
          </v-btn>
          <v-btn
            class="custom-bold-button ms-2"
            depressed
            :disabled="pageLoading"
            color="cyan white--text"
            v-on:click="updateOrCreate()"
          >
            <span>Save</span>
          </v-btn>
        </div>

        <v-row>
          <v-col cols="12">
            <v-card flat class="custom-grey-border remove-border-radius">
              <v-card-title
                class="headline grey lighten-4"
                @click="ManageCard('basic')"
              >
                <h3 class="font-weight-700 custom-headline color-custom-blue">
                  <v-icon>{{
                    !show_add_form ? "mdi-chevron-down" : "mdi-chevron-up"
                  }}</v-icon>
                  Basic Details
                </h3>
              </v-card-title>
              <v-expand-transition>
                <v-card-text class="p-6 font-size-16" v-show="show_add_form">
                  <v-form
                    ref="createTemplateForm"
                    v-model="formValid"
                    lazy-validation
                    v-on:submit.stop.prevent="updateOrCreate()"
                  >
                    <v-row>
                      <v-col md="2" class="my-auto">
                        <label for="" class="v-label">Title</label>
                      </v-col>
                      <v-col md="6">
                        <TextField
                          dense
                          filled
                          solo
                          flat
                          placeholder="Enter Title"
                          hide-details
                          color="cyan"
                          :loading="pageLoading"
                          :disabled="pageLoading"
                          v-model="serviceFormTemplateCreate.title"
                          :rules="[
                            validateRules.required(
                              serviceFormTemplateCreate.title,
                              'Title'
                            ),
                          ]"
                          :maxlength="100"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="2" class="my-auto">
                        <label for="" class="v-label">Description</label>
                      </v-col>
                      <v-col md="6">
                        <TextAreaField
                          auto-grow
                          dense
                          filled
                          color="cyan"
                          v-model.trim="serviceFormTemplateCreate.description"
                          placeholder="Description"
                          solo
                          flat
                          row-height="20"
                          counter="200"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card flat class="custom-grey-border remove-border-radius">
              <v-card-title class="headline grey lighten-4">
                <div class="d-flex justify-space-between align-center w-100">
                  <h3
                    class="font-weight-700 custom-headline color-custom-blue"
                    @click="ManageCard('equipment')"
                  >
                    <v-icon>{{
                      !show_equipment_assign
                        ? "mdi-chevron-down"
                        : "mdi-chevron-up"
                    }}</v-icon>
                    Assign Equipment
                  </h3>
                  <v-btn
                    small
                    depressed
                    class="custom-bold-button"
                    color="cyan white--text"
                    v-on:click="equipmentSelectDialog = true"
                  >
                    <v-icon x-small left>mdi-plus</v-icon>
                    Add Equipment
                  </v-btn>
                </div>
              </v-card-title>
              <v-expand-transition>
                <v-card-text
                  v-show="show_equipment_assign"
                  class="font-size-16 pt-4 pb-0"
                >
                  <div class="form-grp px-5 mb-4">
                    <div>
                      <table
                        class="simple-table"
                        v-if="serviceFormTemplateCreate.equipments_list.length"
                        style="width: 100%; table-layout: fixed"
                      >
                        <thead>
                          <tr>
                            <th class="simple-table-th" width="200">Image</th>
                            <th class="simple-table-th" width="200">Barcode</th>
                            <th class="simple-table-th">Name</th>
                            <th class="simple-table-th" width="200">
                              Serial No.
                            </th>
                            <th class="simple-table-th">Brand</th>
                            <th class="simple-table-th">Category</th>
                            <th class="simple-table-th" width="100">Action</th>
                          </tr>
                        </thead>
                        <tbody class="custom-border-bottom custom-border-top">
                          <tr
                            v-for="(
                              item, index
                            ) in serviceFormTemplateCreate.equipments_list"
                            :key="item.id"
                            class="alternate-listing-row"
                          >
                            <td class="simple-table-td">
                              <template v-if="item.image">
                                <v-img
                                  class="customer-image"
                                  width="50"
                                  height="50"
                                  contain
                                  :lazy-src="$defaultImage"
                                  :src="item.image"
                                ></v-img>
                              </template>
                              <template v-else>
                                <v-img
                                  class="customer-image"
                                  width="50"
                                  height="50"
                                  contain
                                  :lazy-src="$defaultImage"
                                  :src="$defaultImage"
                                ></v-img>
                              </template>
                            </td>
                            <td class="simple-table-td">
                              <template v-if="item.barcode">
                                <Barcode :barcode="item.barcode" />
                              </template>
                              <em v-else class="text-muted"> no barcode </em>
                            </td>
                            <td class="simple-table-td text-capitalize">
                              <template v-if="item.name">
                                {{ item.name || item.name }}</template
                              >
                              <template v-else>
                                <em class="text-muted"> no name </em></template
                              >
                            </td>
                            <td class="simple-table-td">
                              <template v-if="item.serial_no">
                                <div>
                                  <v-chip
                                    color="chip-custom-blue"
                                    label
                                    small
                                    outlined
                                    class="mr-1"
                                  >
                                    {{ item.serial_no }}
                                  </v-chip>
                                </div>
                              </template>
                              <em v-else class="text-muted"> no serial no </em>
                            </td>
                            <td class="simple-table-td">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <template v-if="item.brand">
                                  {{ item.brand }}</template
                                >
                                <template v-else>
                                  <em class="text-muted">
                                    no brand
                                  </em></template
                                >
                              </p>
                            </td>
                            <td class="simple-table-td">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <v-chip
                                  outlined
                                  text-color=""
                                  label
                                  small
                                  color="blue"
                                  v-if="item.category"
                                >
                                  {{ item.category }}
                                </v-chip>
                                <template v-else
                                  ><em class="text-muted"
                                    >No Category</em
                                  ></template
                                >
                              </p>
                            </td>
                            <td class="simple-table-td text-center">
                              <v-icon
                                class="cursor-pointer red--text"
                                v-on:click="removeEquipment(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div
                        v-else
                        class="d-flex justify-center align-center py-3 font-weight-500"
                      >
                        <img
                          width="40px"
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image mr-2"
                        />
                        No equipment assigned yet.
                      </div>
                    </div>
                  </div>
                  <EquipmentSelect
                    :dialog="equipmentSelectDialog"
                    :customer-name="detail?.customer_name || ''"
                    :pre-selected-equipments="
                      serviceFormTemplateCreate.equipments_list
                    "
                    @close="equipmentSelectDialog = false"
                    @equipment-selected="onEquipmentSelected"
                  />
                </v-card-text>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card flat class="custom-grey-border remove-border-radius">
              <v-card-title
                class="headline grey lighten-4"
                @click="ManageCard('builder')"
              >
                <h3 class="font-weight-700 custom-headline color-custom-blue">
                  <v-icon>{{
                    !show_form_builder ? "mdi-chevron-down" : "mdi-chevron-up"
                  }}</v-icon>
                  Cheklist Builder
                </h3>
              </v-card-title>
              <v-expand-transition>
                <v-card-text class="p-6 font-size-16" v-if="show_form_builder">
                  <FormBuilder
                    :data="serviceFormTemplateCreate"
                    :preBuilderData="preBuilderData"
                    :title="serviceFormTemplateCreate.title"
                    v-on:update-data="updateData"
                  />
                </v-card-text>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import FormBuilder from "@/view/pages/serviceFormTemplate/FormBuilder";
import Barcode from "@/view/pages/partials/Barcode.vue";

import EquipmentSelect from "@/view/components/EquipmentSelect.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import {
  POST,
  GET,
  PUT,
  CLEAR_ERROR,
} from "@/core/services/store/request.module";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import { map } from "lodash";

export default {
  mixins: [ValidationMixin],
  name: "Form_builder",
  data() {
    return {
      equipmentList: [],
      preBuilderData: [],
      show_add_form: false,
      show_form_builder: true,
      show_equipment_assign: false,
      templateId: null,
      serviceFormTemplateCreate: {
        title: null,
        checklist_data: [],
        equipments: [],
        equipments_list: [],
      },
      pageLoading: false,
      equipmentSelectDialog: false,
      detail: {},
    };
  },
  methods: {
    ManageCard(type) {
      if (type == "builder") {
        this.show_form_builder = !this.show_form_builder;
        this.show_add_form = false;
        this.show_equipment_assign = false;
      } else if (type == "basic") {
        this.show_form_builder = false;
        this.show_add_form = !this.show_add_form;
        this.show_equipment_assign = false;
      } else if (type == "equipment") {
        this.show_form_builder = false;
        this.show_add_form = false;
        this.show_equipment_assign = !this.show_equipment_assign;
      }
    },
    updateData(data) {
      this.serviceFormTemplateCreate.checklist_data = data;
    },
    updateOrCreate() {
      const _this = this;
      if (!_this.$refs.createTemplateForm.validate()) {
        return false;
      }
      _this.pageLoading = true;
      _this.$store.dispatch(CLEAR_ERROR, {});
      let requestType = POST;
      let requestURL = "setting/checklist";
      if (_this.templateId && _this.templateId > 0) {
        requestType = PUT;
        requestURL = `setting/checklist/${_this.templateId}`;
      }
      let requestData = _this.serviceFormTemplateCreate;
      _this.$store
        .dispatch(requestType, { url: requestURL, data: requestData })
        .then((response) => {
          _this.templateId = response.data ? response.data.id : null;
          _this.goBack();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    loadData() {
      const _this = this;
      this.$store
        .dispatch(GET, { url: `setting/checklist/${_this.templateId}` })
        .then((response) => {
          _this.serviceFormTemplateCreate = response.data;
          _this.detail = response.data;
          if (
            _this.serviceFormTemplateCreate &&
            _this.serviceFormTemplateCreate.checklist_data
          ) {
            _this.preBuilderData =
              _this.serviceFormTemplateCreate.checklist_data;
          }
          if (
            _this.serviceFormTemplateCreate &&
            _this.serviceFormTemplateCreate.equipment
          ) {
            _this.serviceFormTemplateCreate.equipments = map(
              _this.serviceFormTemplateCreate.equipment,
              (row) => row.id
            );
            _this.serviceFormTemplateCreate.equipments_list =
              _this.serviceFormTemplateCreate.equipment;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onEquipmentSelected(equipments) {
      if (equipments && equipments.length > 0) {
        this.serviceFormTemplateCreate.equipments = equipments.map(
          (equipment) => equipment.id
        );
        this.serviceFormTemplateCreate.equipments_list = equipments;
      }
      this.equipmentSelectDialog = false;
    },
    addNewEquipment(index) {
      this.serviceFormTemplateCreate.equipments_list.splice(index + 1, 0, {
        name: null,
        barcode: null,
        id: null,
      });
    },

    // removeEquipment(index) {
    //   console.log("Deleting index:", index);
    //   this.serviceFormTemplateCreate.equipments_list.splice(index, 1);
    //   // Update the equipments array to match
    //   this.serviceFormTemplateCreate.equipments =
    //     this.serviceFormTemplateCreate.equipments_list
    //       .map((e) => e.id)
    //       .filter((id) => id);
    // },
    removeEquipment(index) {
      const list = JSON.parse(
        JSON.stringify(this.serviceFormTemplateCreate.equipments_list)
      );

      list.splice(index, 1);

      // Replace full object reference (important)
      this.serviceFormTemplateCreate = {
        ...this.serviceFormTemplateCreate,
        equipments_list: list,
        equipments: list.map((e) => e.id),
      };

      console.log(
        "After delete:",
        this.serviceFormTemplateCreate.equipments_list
      );
    },
  },
  created() {
    const _this = this;
    _this.templateId = _this.lodash.toSafeInteger(_this.$route.params.id);
  },
  mounted() {
    const _this = this;
    if (_this.$route.name == "admin.serviceFormTemplate.update") {
      if (_this.templateId <= 0) {
        _this.$router.go(-1);
      }

      _this.loadData();
    }
  },
  components: {
    FormBuilder,
    Barcode,
    EquipmentSelect,
    TextAreaField,
  },
};
</script>
<style scoped>
/* tabs css  */

.custom-tab-transparent.v-tabs--fixed-tabs > .v-tabs-bar .v-tab.v-tab--active {
  background-color: #00bcd4 !important;
  color: #fff !important;
  overflow: hidden;
}

.custom-tab-transparent.v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tab.v-tab--active
  .grey--text.text--darken-4 {
  color: #fff !important;
  caret-color: #fff !important;
}

.custom-tab-transparent.v-tabs .v-tab {
  background: #00bcd429;
  width: 25%;
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}
</style>
